module.exports = __webpack_public_path__ + "assets/img/feature-img4-8d26abee.jpg";